import { HugeiconsIcon } from "@hugeicons/react";
import { Alert02Icon } from "@hugeicons-pro/core-stroke-rounded";
import { Button } from "@workspace/frontend-ui";
import type { FC } from "react";
import useRewardCenter from "../../actors/useRewardCenter";
import useTranslations from "../../i18n/useTranslations";

const ACTION = "h-12 w-full rounded-full font-semibold text-sm";

const ErrorView: FC = () => {
  const { send } = useRewardCenter();
  const t = useTranslations();

  return (
    <div
      data-slot="error-view"
      className="flex flex-col items-center gap-6 px-2 pt-3 text-center"
    >
      <span className="grid size-16 place-items-center rounded-full bg-card">
        <HugeiconsIcon icon={Alert02Icon} className="size-7 text-destructive" />
      </span>
      <div className="flex flex-col gap-3">
        <p className="font-semibold text-2xl text-foreground">
          {t("reward_center.error.title")}
        </p>
        <p className="text-muted-foreground text-sm">
          {t("reward_center.error.description")}
        </p>
      </div>
      <div className="flex w-full flex-col gap-2">
        <Button
          className={ACTION}
          onClick={() => send("backend", { type: "loadFrontData" })}
        >
          {t("reward_center.error.retry")}
        </Button>
        <Button
          variant="secondary"
          className={ACTION}
          onClick={() => send("rewardCenter", { type: "contactSupport" })}
        >
          {t("reward_center.error.contact_support")}
        </Button>
      </div>
    </div>
  );
};

export default ErrorView;
